export default __webpack_public_path__ + "static/3-91442cf39892394f69911194092c67ad.jpeg";